import { useCallback, useEffect, useRef, useState } from 'react';
import { Subscription } from 'rxjs';
import * as ApiModels from '@/typings/questionnaires-api-models';
import { getNoodleDb } from '../rxdb.noodle';

type Config = {
  realtime?: boolean;
  enabled?: boolean;
};

function useQuestionnaireTemplate(
  questionnaireTemplateId?: string,
  { realtime = true, enabled = true }: Config = {},
): ApiModels.QuestionnaireTemplateNoFields | null {
  const subscription = useRef<Subscription | null>(null);
  const [questionnaireTemplate, setQuestionnaireTemplate] = useState<ApiModels.QuestionnaireTemplateNoFields | null>(null);

  const getQuestionnaireTemplate = useCallback(async () => {
    try {
      if (!questionnaireTemplateId) return;

      const db = await getNoodleDb();

      subscription.current = db.questionnaireTemplate.findOne({ selector: { id: questionnaireTemplateId } }).$.subscribe(rxQuestionnaireTemplate => {
        if (!rxQuestionnaireTemplate) return;

        const item = rxQuestionnaireTemplate.toMutableJSON() as ApiModels.QuestionnaireTemplateNoFields;
        setQuestionnaireTemplate(item);

        // If not realtime, unsubscribe after first value is set
        if (!realtime) {
          subscription.current?.unsubscribe();
        }
      });
    } catch (error) {
      console.error('RXDB useQuestionnaireTemplate error - getQuestionnaireTemplate()', error);
    }
  }, [questionnaireTemplateId, realtime]);

  useEffect(() => {
    if (enabled) {
      getQuestionnaireTemplate();
    }

    return () => {
      subscription.current?.unsubscribe();
    };
  }, [getQuestionnaireTemplate, enabled]);

  return questionnaireTemplate;
}

export default useQuestionnaireTemplate;
